import React, { useEffect, useState } from "react";
import Table from "../common/Table";
import { useDispatch, useSelector } from "react-redux";
import TableColumn from "./dependencies/TableColumn";
import { PinDoctor, getItemList, updateDoctor } from "./dependencies/action";
import { ROLES } from "../../constants/role";
import AddUpdate from "./AddUpdate/addUpdate";
import { doRegisterDoctor } from "../Auth/dependencies/action";
import { updateProfile } from "../EditProfile/dependiencies/action";
import { updateUserById } from "../Franchise/dependencies/action";
import "./style.scss";
import { getStateCity } from "../Dashboard/dependencies/action";
import DoctorDetailsModal from "./DoctorDetailsModal/DoctorDetailsModal";
import WalletTrackingModal from "../WalletTrackingModal/WalletTrackingModal";
import { useModal } from "../UseModal/UseModal";
import Api from "../../dependencies/utils/Api";
import { exportData } from "../ExportData/EportData";
import DownloadDoctorData from "./DownloadDoctorData/DownloadDoctorData";
import { useNavigate } from 'react-router-dom';
import { GET_DOCTOR_USERS } from "../../constants/ApplicationUrl";

function Doctors() {

  const navigate = useNavigate();

  const {
    showModal: showWalletModal,
    selectedItem: selectedDoctorWallet,
    openModal: handleOpenWalletModal,
    closeModal: handleCloseWalletModal,
  } = useModal();
  
  const [speciality, setSpeciality] = useState([]);
  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        // Fetch data from the API
        const response = await Api.GET(
          `${GET_DOCTOR_USERS}`
        );
        setSpeciality(response.data.speciality);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    };
    fetchTransactions();
  }, []);
  const [printPage, setPrintPage] = useState(false)
  const handlePrint = () => {
    setPrintPage(true);
    navigate('/downloadDoctorData');

  };
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const handleOpenDetailsModal = (doctor) => {
    setSelectedDoctor(doctor);
    setShowDetailsModal(true);
  };

  const handleCloseDetailsModal = () => {
    setSelectedDoctor(null);
    setShowDetailsModal(false);
  };

  const handleOpenModal = (rowData) => {
    console.log("heloo");
    setRowData(rowData);
    setShowAddUpdate(true);
  };

  const [query, setQuery] = useState({
    page: 1,
    limit: 10,
    role: ROLES.DOCTOR,
    filter: "",
    email: "",
    mobile: "",
    activeStatus: "",
    appointment: "",
    availableFor: "",
    fromDate: "",
    toDate: "",
    earningQuery: "",
    specialization: "",
    appointmentStatus: ""
  });

  const [fromDate, setFromDate] = useState(""); // State for fromDate
  const [toDate, setToDate] = useState(""); // State for toDate

  const { ItemList, ItemTotalPage } = useSelector((state) => state.users);
  console.log("itemlisthello", ItemList);
  const dispatch = useDispatch();
  const [showAddUpdate, setShowAddUpdate] = useState(false);

  const [rowData, setRowData] = useState({});
  const [SearchQuery, setSearchQuery] = useState("");
  const { stateList } = useSelector((state) => state.stateCity);
  const [city, setCity] = useState([]);
  console.log(query, ">>>");

  const [additionalFilter, setAdditionalFilter] = useState({
    state: "",
    city: "",
  });
  const [stateListSorted, setStateListSorted] = useState([]);
  const [citySorted, setCitySorted] = useState([]);
  useEffect(() => {
    if (stateList) {
      const sortedStates = stateList.slice().sort((a, b) => a.state.localeCompare(b.state));
      setStateListSorted(sortedStates);
    }
  }, [stateList]);

  useEffect(() => {
    if (city) {
      const sortedCities = city.slice().sort();
      setCitySorted(sortedCities);
    }
  }, [city]);
  const handlePageChange = (page) => {
    setQuery({ ...query, page: page, ...additionalFilter });
  };

  useEffect(() => {
    dispatch(getStateCity());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getItemList({ ...query, ...additionalFilter }));
  }, [query, dispatch, additionalFilter]);

  const handleAdd = (data) => {
    dispatch(doRegisterDoctor(data)).then((res) => {
      if (res.status) {
        setShowAddUpdate(false);
        dispatch(getItemList({ ...query, ...additionalFilter }));
      }
    });
  };

  const handleUpdate = (id, data) => {
    dispatch(updateDoctor(id, data)).then((res) => {
      if (res.status) {
        setShowAddUpdate(false);
        dispatch(getItemList({ ...query, ...additionalFilter }));
      }
    });
  };

  const HandleEdit = (row) => {
    setRowData(row);
    setShowAddUpdate(true);
  };

  const HandlecloseAdd = () => {
    setRowData(null);
    setShowAddUpdate(false);
  };

  const activateDeactivate = (id, status) => {
    dispatch(updateUserById(id, { status })).then((res) => {
      if (res.status) {
        dispatch(getItemList({ ...query, ...additionalFilter }));
      }
    });
  };

  const handleSearch = (e) => {
    const { name, value } = e.target;
    setSearchQuery(value);
    setQuery({ ...query, [name]: value });
  };

  const getRowClass = (row) => {
    if (row.status === "active") {
      return "";
    } else if (row.status === "inactive") {
      return "table-danger";
    }
  };

  const handlePinDoctor = (id, status) => {
    let data = { pinUser: status ? false : true };

    dispatch(PinDoctor(id, data)).then((res) => {
      if (res.status) {
        dispatch(getItemList({ ...query, ...additionalFilter }));
      }
    });
  };

  const handleStatusChange = (e) => {
    const activeStatus = e.target.value;
    setQuery({ ...query, activeStatus: activeStatus });
  };

  const handleSpecialization = (e) => {
    const specialization = e.target.value;
    setQuery({ ...query, specialization: specialization });
  }

  const handleAppointmentChange = (e) => {
    const { name, value } = e.target;
    setQuery({ ...query, [name]: value });
  };

  const handleEarningQuery = (e) => {
    const earningQuery = e.target.value;
    setQuery({ ...query, earningQuery: earningQuery });
  };

  const handleDoctorAvailable = (e) => {
    const availableFor = e.target.value;
    setQuery({ ...query, availableFor: availableFor });
  };

  const handleStateChange = (e) => {
    const stateId = e.target.value;
    if (!stateId) {
      setCity([]); // Reset city dropdown
      setAdditionalFilter({
        ...additionalFilter,
        state: "",
        city: "", // Clear city in additional filter
      });
      setQuery({ ...query, state: "", city: "" });
      return;
    }
    const selectedState = stateList.find((state) => state._id === stateId);
    if (selectedState) {
      const cityOptions = selectedState.city;
      setAdditionalFilter({
        ...additionalFilter,
        state: selectedState.state,
        city: "", // Clear city in additional filter
      });
      setCity(cityOptions);
    }
    setQuery({ ...query, state: stateId, city: "" }); // Reset city in query
  };

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setAdditionalFilter({ ...additionalFilter, city: selectedCity });
    setQuery({ ...query, city: selectedCity });
  };

  const handleApplyDate = (e) => {
    setQuery({ ...query, fromDate: fromDate, toDate: toDate });
  };

  const handleClearFilters = () => {
    setQuery({
      page: 1,
      limit: 10,
      role: ROLES.DOCTOR,
      filter: "",
      email: "",
      mobile: "",
      activeStatus: "",
      appointment: "",
      availableFor: "",
      fromDate: "",
      toDate: "",
      earningQuery: "",
      state: "",
      city: "",
      specialization: "",
      appointmentStatus: ""
    });
    setFromDate(""); // Reset fromDate state
    setToDate(""); // Reset toDate state
    setAdditionalFilter({
      state: "",
      city: "",
    });
    setCity([]); // Reset city state
    setSearchQuery(""); // Reset search query state
  };

  const handleFromDateChange = (e) => {
    const selectedFromDate = e.target.value;
    setFromDate(selectedFromDate);
    if (toDate && selectedFromDate > toDate) {
      setToDate('');
    }
  };
  const handleToDateChange = (e) => {
    const selectedToDate = e.target.value;
    setToDate(selectedToDate);
  };



  return (
    <>
      <head>
        <title>Fever99</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </head>
      <div className="page-wrapper">
        <div className="content">
          <div className="col-sm-4 col-3">
            <h4 className="page-title">Doctors</h4>
          </div>

          <div className="row">
            <div className="form-group col-lg-3 mt-3">
              <label>Search By Name</label>

              <input
                className="form-control"
                name="filter"
                placeholder="Name"
                value={query.filter}
                onChange={handleSearch}
              />
            </div>
            <div className="form-group col-lg-3 mt-3">
              <label>Search By Email</label>
              <input
                className="form-control"
                name="email"
                value={query.email}
                placeholder="Email"
                onChange={handleSearch}
              />
            </div>
            <div className="form-group col-lg-3 mt-3">
              <label>Search By Mobile</label>
              <input
                className="form-control"
                name="mobile"
                value={query.mobile}
                placeholder="Mobile"
                onChange={handleSearch}
              />
            </div>
            <div className="form-group col-lg-3 mt-3">
              <label>Search By Status</label>
              <select
                className="form-select"
                name="activeStatus"
                value={query.activeStatus}
                onChange={handleStatusChange}
              >
                <option value="">--Select Status--</option>
                <option value="">All</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
            <div className="form-group col-lg-3 mt-3">
              <label>Search By Specialization</label>
              <select
                className="form-select"
                name="specialization"
                value={query.specialization}
                onChange={handleSpecialization}>
                <option value="">--Select Specialization--</option>
                {speciality &&
                  speciality.map((item, index) => (
                    <option value={item.value} key={index}>
                      {item.label}
                    </option>
                  ))}
              </select>
            </div>

            <div className="form-group col-lg-3 mt-3">
              <label>Search By Appointment</label>
              <select
                className="form-select"
                name="appointment"
                value={query.appointment}
                onChange={handleAppointmentChange}
              >
                <option value="">--By Appointment--</option>
                <option value="">All</option>
                <option value="max">Maximum</option>
                <option value="min">Minimum</option>
              </select>
            </div>
            <div className="form-group col-md-3 mt-3">
              <label>Search By Appointment Status</label>
              <select
                className="form-select"
                name="appointmentStatus"
                value={query.appointmentStatus}
                onChange={handleAppointmentChange}
              >
                <option value="">--By Appointment Status--</option>
                <option value="">All</option>
                <option value="pending">Pending</option>
                <option value="confirmed">Confirmed</option>
                <option value="cancelled">Cancelled</option>
                <option value="completed">Completed</option>
                <option value="rejected">Rejected</option>
                <option value="accepted">Accepted</option>
                <option value="rescheduled">Rescheduled</option>

              </select>
            </div>
            <div className="form-group col-lg-3 mt-3">
              <label>Search By Doctor Avalaible For</label>
              <select
                className="form-select"
                name="availableFor"
                value={query.availableFor}
                onChange={handleDoctorAvailable}
              >
                <option value="">--Doctor Available for--</option>
                <option value="">All</option>
                <option value="franchise">Franchise</option>
                <option value="patient">Patient</option>
              </select>
            </div>
            <div className="form-group col-lg-3 mt-3">
              <label>Search By State</label>
              <select
                className="form-select"
                onChange={(e) => handleStateChange(e)}
              >
                <option value="">--Select State--</option>
                {stateListSorted &&
                  stateListSorted.map((sta, index) => (
                    <option value={sta._id} key={index}>
                      {sta.state}
                    </option>
                  ))}
              </select>
            </div>
            <div className="form-group col-lg-3 mt-3">
              <label>Search By City</label>
              <select
                className="form-select"
                onChange={(e) => handleCityChange(e)}>
                <option value="">--Select City--</option>
                {citySorted &&
                  citySorted.map((c, index) => (
                    <option value={c} key={index}>
                      {c}
                    </option>
                  ))}
              </select>
            </div>
            <div className="form-group col-lg-3 mt-3">
              <label>Search By Earning</label>
              <select
                className="form-select"
                name="earningQuery"
                value={query.earningQuery}
                onChange={handleEarningQuery}
              >
                <option value="">--By Earning--</option>
                <option value="">All</option>
                <option value="max">Maximum</option>
                <option value="min">Minimum</option>
              </select>
            </div>
            <div className="form-group col-lg-3 mt-3">
              <label>From Date</label>
              <input
                type="date"
                name="fromDate"
                className="form-control"
                value={fromDate}
                onChange={handleFromDateChange}
              />
            </div>
            <div className="form-group col-lg-3 mt-3">
              <label>To Date</label>
              <input
                type="date"
                name="toDate"
                className="form-control"
                value={toDate}
                min={fromDate} // Set the minimum allowed date for "To Date" as the selected "From Date"
                onChange={handleToDateChange}
              />
            </div>
          </div>
          <div className="row d-flex justify-content-center">
            <div className="col-md-1 mt-3">
              <button
                className="btn btn-sm btn-info"
                style={{ marginTop: "27px" }}
                onClick={(e) => handleApplyDate(e)}
                type="button"
              >
                Apply
              </button>
            </div>
            <div className="col-md-2 mt-3">
              <button
                className="btn btn-secondary mt-4"
                onClick={handleClearFilters}
                type="button"
              >
                Clear Filters
              </button>
            </div>
          </div>
          <a
            href="#0"
            className="btn btn-sm btn-success mb-1 mt-3"
            onClick={() => setShowAddUpdate(true)}
          >
            Add Doctor
          </a>
          <button className="btn btn-sm btn-secondary mb-1 mt-3 mx-2" onClick={handlePrint}>
            Print
          </button>
          {printPage && <DownloadDoctorData ItemList={ItemList} />}

          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <Table
                      columns={TableColumn({
                        HandleEdit,
                        activateDeactivate,
                        handlePinDoctor,
                        pageNo: query.page,
                        size: query.size,
                        openModal: handleOpenDetailsModal,
                        openWalletModal: handleOpenWalletModal,
                      })}
                      dataTable={ItemList}
                      totalRecord={ItemTotalPage}
                      onPageChange={handlePageChange}
                      onTableChange={() => { }}
                      getRowClass={getRowClass}
                      keyField="_id"
                      sizePerPage={query.size}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddUpdate
        show={showAddUpdate}
        handleClose={(value) => HandlecloseAdd(value)}
        handleAdd={(data) => handleAdd(data)}
        handleUpdate={(id, data) => handleUpdate(id, data)}
        data={{ rowData: rowData }}
      />
      <DoctorDetailsModal
        show={showDetailsModal}
        handleClose={handleCloseDetailsModal}
        doctor={selectedDoctor}
      />
      <WalletTrackingModal
        show={showWalletModal}
        handleClose={handleCloseWalletModal}
        doctor={selectedDoctorWallet}
        type="doctorWallet"
      />
    </>
  );
}

export default Doctors;
